'use client';

import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/image';

const SvgRenderer = ({
  svgText,
  className,
  color = '#818898',
  imgClass,
}: {
  svgText: string;
  className?: string;
  color?: string;
  imgClass?: string;
}) => {
  if (!svgText) return;

  const cleanedSVG = DOMPurify.sanitize(svgText);
  const modifiedSvgText = cleanedSVG.replace(
    /fill="[^"]*"/g,
    `fill="${color}"`
  );

  return (
    <span className={className}>
      <Image
        src={`data:image/svg+xml,${encodeURIComponent(modifiedSvgText)}`}
        alt="icon"
        width={24}
        height={24}
        className={` object-contain ${imgClass ? imgClass : 'w-full h-full'}`}
      />
    </span>
  );
};

export default SvgRenderer;
